

var isDebug = false;



var helper={ 
	log:function(msg){
		if(isDebug){
			console.log(msg);
		}	
	},
	sortList:function(type,val,arr,key){
		//type:1数字,0字符
		//val:0升序,1降序
		return arr.sort(function(a,b){
			var x=a[key];
			var y=b[key];
			if(type == 1){
				if(val){return ((x>y) ? -1 : ( (x < y) ? 1 : 0) );}
				else{return ((x<y) ? -1 : ((x > y) ? 1 : 0) );}
			}else{
				if(val){return x.localeCompare(y);}
				else{return y.localeCompare(x);}
			}
			
			
		})
		
	},
	htmltitle:function(title){
		 document.title=title;
	}
}

export default helper


// WEBPACK FOOTER //
// ./src/global/js/helper.js